export default __webpack_public_path__ + "static/media/forgot_password_OTP.2db2a561.webp";